import { DqCard, DqCardContent, DqIcon } from "@decentriq/components";
import { Box, Chip, Stack, Tooltip, Typography } from "@mui/joy";
import { memo, useMemo } from "react";
import {
  mediaDataRoomOrganizationPermissionsMap,
  type MediaDataRoomParticipant,
  mediaDataRoomParticipantRoleCardPresentation,
} from "features/mediaDataRoom/models";

interface ParticipantCardProps {
  participant: MediaDataRoomParticipant;
}

const ParticipantCard = memo<ParticipantCardProps>(
  ({ participant: { role, name, logo, isCurrentUser, permissions } }) => {
    const participantRoleLabel = useMemo(
      () =>
        `${mediaDataRoomParticipantRoleCardPresentation[role].title}${isCurrentUser ? " (You)" : ""}`,
      [isCurrentUser, role]
    );

    return (
      <DqCard color="primary" label={participantRoleLabel}>
        <DqCardContent gap={1}>
          <Stack alignItems="center" justifyContent="center" minHeight="140px">
            <Typography
              fontWeight={600}
              level="title-md"
              sx={{ color: "initial" }}
              textAlign="center"
            >
              {name}
            </Typography>
            <Box height="40px">
              {logo && (
                <DqIcon
                  icon={`data:image;base64,${logo}`}
                  iconProps={{ height: "100%" }}
                />
              )}
            </Box>
          </Stack>
          {permissions.length > 0 && (
            <Stack direction="row" flexWrap="wrap" gap={1}>
              <Tooltip
                title={permissions
                  .map((e) => mediaDataRoomOrganizationPermissionsMap[e])
                  .join(", ")}
              >
                <Stack direction="row" flexWrap="wrap" gap={1}>
                  <Chip sx={{ borderRadius: 0 }}>
                    {mediaDataRoomOrganizationPermissionsMap[permissions[0]]}
                  </Chip>
                  {permissions.length > 1 && (
                    <Chip
                      sx={{ borderRadius: 0 }}
                    >{`+ ${permissions.length - 1}`}</Chip>
                  )}
                </Stack>
              </Tooltip>
            </Stack>
          )}
        </DqCardContent>
      </DqCard>
    );
  }
);

ParticipantCard.displayName = "ParticipantCard";

export default ParticipantCard;
